import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'

import { useEffect, useState } from 'react'
import { Document, Page } from 'react-pdf'

import { fetchReceiptFileUrl } from '@/api/services/receipt'
import { PDF_RESOURCE_OPTIONS } from '@/lib/pdf-config'

type Props = {
  receiptId: number
  pageCount: number
}

/**
 * レシートのスキャンPDFを表示する。
 *
 * 認証ヘッダが要るので直接 src には渡せず、Blob を取ってから Object URL にする。
 */
export const ReceiptPdfView = ({ receiptId, pageCount }: Props) => {
  const [fileUrl, setFileUrl] = useState<string | null>(null)
  const [failed, setFailed] = useState(false)
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const controller = new AbortController()
    let objectUrl: string | null = null

    setFileUrl(null)
    setFailed(false)
    fetchReceiptFileUrl(receiptId, controller.signal)
      .then((url) => {
        // 取得中にレシートが切り替わったら、作った Object URL は捨てる
        if (controller.signal.aborted) {
          URL.revokeObjectURL(url)
          return
        }
        objectUrl = url
        setFileUrl(url)
      })
      .catch(() => {
        if (controller.signal.aborted) return
        setFailed(true)
      })

    return () => {
      controller.abort()
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [receiptId])

  useEffect(() => {
    if (!container) return
    setWidth(container.clientWidth)
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width))
    observer.observe(container)
    return () => observer.disconnect()
  }, [container])

  return (
    <div ref={setContainer} className="h-full overflow-y-auto bg-neutral-900">
      {failed && <p className="p-4 text-sm text-red-500">PDFを読み込めませんでした。</p>}
      {!failed && !fileUrl && <p className="p-4 text-sm text-muted-foreground">PDFを読み込み中…</p>}
      {fileUrl && width > 0 && (
        <Document file={fileUrl} options={PDF_RESOURCE_OPTIONS} loading={null}>
          {Array.from({ length: pageCount }, (_, index) => (
            <Page key={index} pageNumber={index + 1} width={width} />
          ))}
        </Document>
      )}
    </div>
  )
}
